import classNames from 'classnames';
import './Badge.scss';

interface BadgeProps {
  className?: string;
  children: React.ReactNode;
  size?: 'xl' | 'lg' | 'md' | 'sm';
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'outline';
  disabled?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export const Badge = ({
  className,
  children,
  size = 'md',
  variant = 'primary',
  disabled = false,
  active = false,
  onClick,
}: BadgeProps) => {
  return (
    <div
      className={classNames('Badge', className, size, variant, { disabled, active })}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
